import { LessonPlanItemFormFields } from '@/components/lesson-plan/LessonPlanItemInlineForm';
import LessonPlanItem, {
  LessonPlanItemContentType,
} from '@/models/LessonPlanItem';

export const lessonPlanItemToFields = (
  item?: LessonPlanItem,
): LessonPlanItemFormFields => ({
  name: item?.name ?? '',
  contentType: item?.isEvaluation
    ? LessonPlanItemContentType.EVALUATION
    : LessonPlanItemContentType.REGULAR,
  time: item?.time ?? null,
  assessmentId: item?.assessmentItem?.assessmentId ?? null,
  assessmentItemId: item?.assessmentItem?.id ?? null,
});
